const panelConstants = {
    None:0,
    Region: 1,
    Site: 2,
    Feature:3
}
module.exports = { panelConstants }